/**
 * The Clients app has exactly TWO small-label roles, and these are them. Every
 * `<th>`, `<dt>` and field caption in the feature uses one of these constants —
 * never a hand-written near-copy — because two nearly identical capitals
 * treatments at different sizes read as a template rather than a voice.
 *
 * `COLUMN_LABEL` is the kit's own `TableHead` treatment
 * (`packages/ui/src/Table.tsx`), verbatim. The kit primitive is the authority:
 * it is the one value the platform shell and every feature can converge on
 * without anybody inventing a third costume.
 *
 * ⚠ COUNTERPART: the platform shell declares the SAME treatment under its own
 * name, `SMALL_LABEL_CLASS` in `apps/dashboard/src/app/shell/labels.ts`, for the
 * launcher group headers and the gear menu. The two class sets are identical on
 * purpose. Two names for one treatment can drift silently, so a change to either
 * one is a change to the kit primitive first and then to BOTH of these — never
 * to one.
 *
 * `FIELD_LABEL` is deliberately NOT capitals. A column header labels a column a
 * reader scans down; a `<dt>` names one value sitting beside it. Different jobs
 * get different treatments — and this one already had to match something: below
 * `md` the responsive-table CSS prints its own reflowed labels in sentence case
 * at weight 500, so an inline field label in tracked caps would disagree with
 * the same feature's own phone layout.
 */

/** Column headers, and any label that heads a scanned column. */
export const COLUMN_LABEL = 'font-semibold text-2xs text-muted-foreground uppercase tracking-wide';

/** Inline `<dt>` labels naming a single value beside them. */
export const FIELD_LABEL = 'font-medium text-2xs text-muted-foreground';
